"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCharacter = void 0;
const react_1 = require("react");
const native_base_1 = require("native-base");
const react_redux_1 = require("react-redux");
const rootNavigation_1 = require("../navigation/rootNavigation");
const user_1 = require("../slices/user");
const character_1 = require("../slices/character");
const subscription_1 = require("../slices/subscription");
const appState_1 = require("../slices/appState");
const useDevice_1 = require("./useDevice");
const useAppMessage_1 = require("./useAppMessage");
const useConversations_1 = require("./useConversations");
const useAppQuota_1 = require("./useAppQuota");
const character_2 = require("../services/character");
const utils_1 = require("../helper/utils");
const application_host_1 = require("../common/application-host");
const react_native_1 = require("react-native");
const useRequest_1 = __importDefault(require("./useRequest"));
const useCharacter = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { request, customRequest } = (0, useRequest_1.default)();
    const { showNotification } = (0, useAppMessage_1.useAppMessage)();
    const appUser = (0, react_redux_1.useSelector)((state) => state.getUserOptions.appUser);
    const selectedCharacter = (0, react_redux_1.useSelector)((state) => state.getUserOptions.characterProfile);
    const conversation = (0, react_redux_1.useSelector)((state) => state.getUserOptions.conversation);
    const { pickConversation, sendInitialConversationMessege } = (0, useConversations_1.useConversations)();
    const { isTabOrDesktopDevice, isWebDevice } = (0, useDevice_1.useDevice)();
    /**
     *
     */
    const handleSelectCharacter = (0, react_1.useCallback)(async (character, redirectNavigation, tutorMode) => {
        const isTablet = isTabOrDesktopDevice;
        pickConversation(character.id.toString());
        if (!isTablet) {
            (0, rootNavigation_1.push)("OneToOneChat", {
                characterId: character.id.toString(),
                ...tutorMode && { tutorMode },
            });
        }
        else {
            console.log('EXCEPTIOn Redirect....');
            (0, rootNavigation_1.navigate)("Chats", {
                characterId: character.id.toString(),
                ...tutorMode && { tutorMode },
            });
            // refresh on tablet
            // navigate(DISCOVER_MODE ? "Chats" : "AllCharacterList", { selectedNew: true });
            // dispatch(setRefreshMessages(true));
        }
    }, [isTabOrDesktopDevice, isWebDevice, conversation, selectedCharacter, pickConversation]);
    const refreshStoreMessages = (0, react_1.useCallback)(async (id) => {
        const messages = await dispatch((0, character_1.getConversationMessagesAsync)(id));
        if (messages?.payload?.success) {
            console.log("Store new conversation messages..");
            const conversations = messages?.payload?.data;
            await dispatch((0, user_1.setStoredMessages)((0, utils_1.sortedConversations)(conversations)));
        }
    }, []);
    /**
     *
     */
    const handleSetCharacterMood = (0, react_1.useCallback)(async (mood, selectedConversationId) => {
        const currentConversationId = selectedConversationId;
        if (currentConversationId) {
            const conversationDTO = { mood: mood || "" };
            const newConversationResponse = await request(character_2.updateConversations, currentConversationId, conversationDTO);
            if (newConversationResponse) {
                await dispatch((0, user_1.setConversation)(newConversationResponse.data));
                await refreshStoreMessages(currentConversationId);
                setTimeout(() => {
                    console.log("handleSetCharacterMood....");
                    sendInitialConversationMessege(currentConversationId);
                }, 200);
                console.log("Done saving mod:", {
                    id: currentConversationId || "",
                    params: conversationDTO,
                });
            }
            return newConversationResponse;
        }
    }, [request]);
    /**
     *
     */
    const handlSetCharacterTutorMode = (0, react_1.useCallback)(async (selectedTutorMode, selectedConversationId) => {
        const currentConversationId = selectedConversationId;
        if (currentConversationId) {
            const conversationDTO = { tutorMode: selectedTutorMode };
            let newConversation = await dispatch((0, character_1.updateConversationsAsync)({
                id: currentConversationId || "",
                params: conversationDTO,
            }));
            if (newConversation?.payload && newConversation?.payload?.success) {
                await dispatch((0, user_1.setConversation)(newConversation?.payload?.data || ""));
                await refreshStoreMessages(currentConversationId);
                console.log("Updated tutor mode:", {
                    id: currentConversationId || "",
                    params: conversationDTO,
                });
                setTimeout(async () => {
                    sendInitialConversationMessege(currentConversationId);
                    // dispatch(setIsTyping(true));
                }, 200);
            }
            else {
                console.log("Tutor mode change error?");
            }
            return newConversation;
        }
    }, []);
    const { loadUserQuota } = (0, useAppQuota_1.useAppQuota)();
    const toast = (0, native_base_1.useToast)();
    const handleCloneCharacter = (0, react_1.useCallback)(async () => {
        await dispatch((0, user_1.setSyncLoading)(true));
        const payLoad = {
            attitude: selectedCharacter?.attitude || "",
            description: selectedCharacter?.description || "",
            background: selectedCharacter?.background || "",
            characterName: selectedCharacter?.characterName || "",
            visibility: false, // convert to string?
            // id: selectedCharacter?.id,
        };
        const formData = new FormData();
        formData.append("payload", JSON.stringify(payLoad));
        const generatedImageUrl = (0, application_host_1.getImageUrl)(selectedCharacter);
        // let ext = selectedCharacter?.extension;
        let ext = generatedImageUrl?.split(".")?.pop();
        var filename = generatedImageUrl?.split("/")?.pop();
        if (filename && ext) {
            console.log("Image ext payload:", ext, filename, generatedImageUrl);
            const pic = {
                name: filename,
                type: `image/${ext}`,
                uri: generatedImageUrl,
            };
            console.log("pic:", pic);
            formData.append("file", pic);
            // formData.append("generationId", generationId);
        }
        await (0, character_2.createEditCharacter)(formData, false).then(async (json) => {
            console.log("Saved character:", json);
            const character = json?.data?.id ? json?.data : json;
            if (character?.characterId) {
                console.log("Created/edited new character!");
                console.log("Set character!", character?.id, character);
                await dispatch((0, user_1.setCharacter)(character));
                // Character profile was not available, we are creating new character
                await dispatch((0, user_1.setConversation)(null));
                await dispatch((0, user_1.setStoredMessages)([]));
                // Update character quota
                if (appUser?.id) {
                    const quota = await loadUserQuota();
                    if (quota) {
                        dispatch((0, subscription_1.setUserQuota)({ uid: appUser?.id, ...quota }));
                    }
                }
                // await handleCreateInitialConversation();
                dispatch((0, user_1.setSyncLoading)(false));
                (0, rootNavigation_1.replace)("CharacterProfile", {
                    character_id: character?.id,
                });
                // setTimeout(async () => {
                //   // await dispatch(setCharacterLoading(null));
                //   console.log("redirect to 1-1 chat....");
                //   navigate("OneToOneChat");
                // }, 100);
            }
            else {
                console.log("json:", json);
                dispatch((0, user_1.setSyncLoading)(false));
                if (!toast.isActive("talkCharacterNew"))
                    showNotification("API error", "Error while creating new character.", "error");
            }
        }, (reason) => {
            dispatch((0, user_1.setSyncLoading)(false));
            console.log("character reason:", reason);
            showNotification("API Error", "Error while creating new character.", "error");
        });
        console.log("payLoad:", payLoad);
        console.log("selectedCharacter: clone:", selectedCharacter);
    }, [selectedCharacter]);
    const characterQuota = (0, react_redux_1.useSelector)((state) => state.subscriptionPlan?.quota?.characters);
    const fbUser = (0, react_redux_1.useSelector)((state) => state.getUserOptions.fbUser);
    /**
     *
     */
    const handleCreateNewCharacter = (0, react_1.useCallback)(async () => {
        if (characterQuota?.quota &&
            characterQuota?.quota === characterQuota?.consumed) {
            if (!fbUser?.uid) {
                dispatch(react_native_1.Platform.OS ? (0, appState_1.setIsLogging)(true) : (0, user_1.setUserAction)("signin"));
            }
            else {
                await dispatch((0, user_1.setUserAction)("membership"));
            }
        }
        else {
            await dispatch((0, user_1.resetCharacter)());
            // navigate("CharacterPrompt");
        }
    }, [fbUser, characterQuota]);
    return {
        handleSelectCharacter,
        handleSetCharacterMood,
        handleCloneCharacter,
        refreshStoreMessages,
        handlSetCharacterTutorMode,
    };
};
exports.useCharacter = useCharacter;
